import { useEffect, useRef } from 'react';
import { formTracker } from '../utils';

function useGAFormTracking(stepName: string) {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (formRef.current) {
      formTracker.registerFormElement(formRef.current);
    }
  }, [formRef]);

  // formTracker has no dedup guard, so this stays mount-only.
  useEffect(() => {
    formTracker.trackStepView({ stepName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return formRef;
}

export { useGAFormTracking };
